module.exports = __webpack_public_path__ + "assets/img/yuyan.65662949.png";